// As entregas do caixa: em produção, em rota e entregues.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const TabelaDePedidosDeDelivery: React.FC<{
  component: any;
  componentProps: any;
  subsidiaryDataZustand: any;
  ordersTypeTable: string;
  setOrdersTypeTable: (tipo: string) => void;
  handleSearchByOrderTable: (orderUuid: any, order?: any, customer?: any) => void;
  getPeriodInfo: () => void;
}> = ({
  component,
  componentProps,
  subsidiaryDataZustand,
  ordersTypeTable,
  setOrdersTypeTable,
  handleSearchByOrderTable,
  getPeriodInfo,
}) => {

  let currentOrders: any[] =
    subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodOrders?.filter(
      (order: any) => order.orderType === 3
    ) ?? [];

  const customers = subsidiaryDataZustand.subsidiaryInfo
    .map((info: any) => {
      if (info.subsidiaryInfoType === 1) {
        return {
          subsidiaryInfoValue: typeof info.subsidiaryInfoValue === "string"
            ? JSON.parse(info.subsidiaryInfoValue)
            : info.subsidiaryInfoValue,
        };
      }
      return null;
    })
    .filter((info: any) => info !== null)[0]?.subsidiaryInfoValue?.Customers || [];

  const deliveryMans =
    subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo
      ?.periodDeliveryMans?.DeliveryMans;

  const deliveryManMap = deliveryMans
    ? Object.fromEntries(
      deliveryMans.map((deliveryMan: any) => [
        deliveryMan.userUuid,
        deliveryMan,
      ])
    )
    : {};

  return (
    <Styles.CurrentOrdersTable
      selected={Boolean(component.componentSelected)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
      componentFontSize={String(componentProps.componentFontSize)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <span className="componentTitle">ATENDIMENTOS EM ANDAMENTO</span>
      <Styles.OrdersTypeButtons>
        <Styles.ShowOrdersTypeButton
          componentBackgroundColor="#1c50fe"
          onClick={() => {
            getPeriodInfo();
            setOrdersTypeTable("OpenOrders");
          }}
        >
          {`Em Produção (${currentOrders?.filter(
            (order: any) =>
              order.orderStatus <= 3 && order.orderStatus > 1
          ).length})`}
        </Styles.ShowOrdersTypeButton>
        <Styles.ShowOrdersTypeButton
          componentBackgroundColor="#1c50fe"
          onClick={() => {
            getPeriodInfo();
            setOrdersTypeTable("DeliveryOrders");
          }}
        >
          {`Em Entrega (${currentOrders?.filter(
            (order: any) => order.orderStatus === 4
          ).length})`}
        </Styles.ShowOrdersTypeButton>
      </Styles.OrdersTypeButtons>

      {ordersTypeTable === "OpenOrders" && (
        <Styles.OpenOrdersTable
          componentBrightness={"0.9"}
          componentStatus={String(componentProps.componentStatus)}
          componentBackgroundColor="transparent"
          componentColor={String(componentProps.componentColor)}
          componentHeight={String(componentProps.componentHeight)}
        >
          <Styles.OpenOrdersTableHeader
            componentColor={String(componentProps.componentColor)}
          >
            <Styles.OpenOrdersTableHeaderRow>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"15%"}>
                Pedido
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Cliente
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Endereço
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"15%"}>
                Status
              </Styles.OpenOrdersTableHeaderCell>
            </Styles.OpenOrdersTableHeaderRow>
          </Styles.OpenOrdersTableHeader>
          {currentOrders.map((order: any, index: number) => {
            const orderInfoCustomerAddress = order.orderInfo.find(
              (info: any) => info.orderInfoType === 9
            );
            const customerAddressOrder = orderInfoCustomerAddress
              ? (typeof orderInfoCustomerAddress.orderInfoValue === "string"
                ? JSON.parse(orderInfoCustomerAddress.orderInfoValue)
                : orderInfoCustomerAddress.orderInfoValue)
              : null;

            if (!customerAddressOrder) {
              return null; // Ignorar se não houver endereço do cliente
            }

            const customer = customers.find(
              (customer: any) =>
                customer.customerUuid === customerAddressOrder?.customerUuid
            );

            if (!customer || !customer.customerAddresses) {
              return null; // Ignorar se não houver cliente ou endereço
            }

            const customerAddress = customer.customerAddresses.find(
              (address: any) =>
                address.customerAddress === customerAddressOrder?.customerAddress
            );

            return order.orderStatus <= 3 && order.orderStatus > 1 ? (
              <Styles.OpenOrdersTableRow
                key={order.orderUuid}
                onClick={() => {
                  handleSearchByOrderTable(order.orderUuid, null, {
                    ...customer,
                    ...customerAddress,
                  });
                  getPeriodInfo();
                }}
              >
                <Styles.OpenOrdersTableCell columnWidth={"15%"}>
                  {order.orderCode}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {`${customer.customerName} - ${customer.customerPhone}`}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {customerAddress?.customerAddress || "Endereço não encontrado"}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"15%"}>
                  {order.orderStatus === 0
                    ? "Recebido"
                    : order.orderStatus === 1
                      ? "Aberto"
                      : order.orderStatus === 2
                        ? "Em Produção"
                        : order.orderStatus === 3
                          ? "Pronto"
                          : ""}
                </Styles.OpenOrdersTableCell>
              </Styles.OpenOrdersTableRow>
            ) : null;
          })}
        </Styles.OpenOrdersTable>
      )}

      {ordersTypeTable === "DeliveryOrders" && (
        <Styles.DeliveryOrdersTable
          componentBrightness={"0.9"}
          componentStatus={String(componentProps.componentStatus)}
          componentBackgroundColor="transparent"
          componentColor={String(componentProps.componentColor)}
          componentHeight={String(componentProps.componentHeight)}
        >
          <Styles.DeliveryOrdersTableHeader
            componentColor={String(componentProps.componentColor)}
          >
            <Styles.DeliveryOrdersTableHeaderRow>
              <Styles.DeliveryOrdersTableHeaderCell columnWidth={"15%"}>
                Pedido
              </Styles.DeliveryOrdersTableHeaderCell>
              <Styles.DeliveryOrdersTableHeaderCell columnWidth={"30%"}>
                Cliente
              </Styles.DeliveryOrdersTableHeaderCell>
              <Styles.DeliveryOrdersTableHeaderCell columnWidth={"25%"}>
                Endereço
              </Styles.DeliveryOrdersTableHeaderCell>
              <Styles.DeliveryOrdersTableHeaderCell columnWidth={"30%"}>
                Entregador
              </Styles.DeliveryOrdersTableHeaderCell>
            </Styles.DeliveryOrdersTableHeaderRow>
          </Styles.DeliveryOrdersTableHeader>
          {currentOrders.map((order: any, index: number) => {
            const orderInfoCustomerAddress = order.orderInfo.find(
              (info: any) => info.orderInfoType === 9
            );
            const customerAddressOrder = orderInfoCustomerAddress
              ? (typeof orderInfoCustomerAddress.orderInfoValue === "string"
                ? JSON.parse(orderInfoCustomerAddress.orderInfoValue)
                : orderInfoCustomerAddress.orderInfoValue)
              : null;

            if (!customerAddressOrder) {
              return null; // Ignorar se não houver endereço do cliente
            }

            const customer = customers.find(
              (customer: any) =>
                customer.customerUuid === customerAddressOrder?.customerUuid
            );

            if (!customer || !customer.customerAddresses) {
              return null; // Ignorar se não houver cliente ou endereço
            }

            const customerAddress = customer.customerAddresses.find(
              (address: any) =>
                address.customerAddress === customerAddressOrder?.customerAddress
            );

            const deliveryManOrderInfo = order.orderInfo.find(
              (info: any) => info.orderInfoType === 6
            );
            const deliveryManOrderInfoValue = deliveryManOrderInfo
              ? deliveryManOrderInfo.orderInfoValue
              : null;

            const deliveryMan = deliveryManOrderInfoValue
              ? deliveryManMap[deliveryManOrderInfoValue]
              : null;

            return order.orderStatus === 4 ? (
              <Styles.OpenOrdersTableRow
                key={order.orderUuid}
                onClick={() => {
                  handleSearchByOrderTable(order.orderUuid, null, {
                    ...customer,
                    ...customerAddress,
                  });
                  getPeriodInfo();
                }}
              >
                <Styles.OpenOrdersTableCell columnWidth={"15%"}>
                  {order.orderCode}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"30%"}>
                  {customer
                    ? `Fone: ${customer.customerPhone} - Nome: ${customer.customerName}`
                    : ""}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"25%"}>
                  {customerAddress?.customerAddress || "Endereço não encontrado"}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"30%"}>
                  {deliveryMan ? deliveryMan.userSocialName : ""}
                </Styles.OpenOrdersTableCell>
              </Styles.OpenOrdersTableRow>
            ) : null;
          })}
        </Styles.DeliveryOrdersTable>
      )}
    </Styles.CurrentOrdersTable>
  );
};
